import React, { type ReactNode, memo } from 'react';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import { IccProvider } from '@atlassian/jira-platform-inline-card-create/src/services/context/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	children: ReactNode;
	projectId?: number;
};

// all root level Board providers
export const BoardProvider = memo<Props>((props: Props) => {
	const { children, projectId } = props;

	const iccProjectId = fg('jsw_board_backlog_inline_issue_type_config_prereq')
		? projectId
		: undefined;

	return fg('tnk-4942_pir_cmp_board_sla_unhandled_fe_excp') ? (
		<IccProvider projectId={iccProjectId}>{children}</IccProvider>
	) : (
		<AppBase>
			<IccProvider projectId={iccProjectId}>{children}</IccProvider>
		</AppBase>
	);
});
